import React from 'react';
import { Button, ButtonProps } from '@mui/material';
interface CustomButtonProps extends ButtonProps {
    borderColor?: string;
    textColor?: string;
}

const CustomButton: React.FunctionComponent<CustomButtonProps> = (props) => {
    // `borderColor` y `textColor` se sacan para que no lleguen al DOM.
    const { borderColor: _borderColor, textColor, ...buttonProps } = props;

    return <Button {...buttonProps}>{props.children}</Button>;
};

export default CustomButton;
